import snGame from "../assets/images/snooker-game.jpg";
import { apiService } from "../services/apiService";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef, useMemo } from "react";
import { useTheme } from "../contexts/ThemeContext";
import { Checkbox } from 'semantic-ui-react';
import "../assets/css/GamesPage.css";

export const GameCard = ({ game, creationType, onEdit, onDelete, navigate }) => {
    return (
        <div className="game-card-modern" key={game.id}>
            <div className="game-card-img-wrapper">
                <img src={snGame} alt="Snooker Game" className="game-card-img" />
                <div className="game-card-overlay" onClick={() => creationType === 'default' ? navigate(`/game/${game.link}`) : onEdit(game)}>
                    <span className="btn btn-primary btn-pill">View Match</span>
                </div>
            </div>
            <span className="game-card-status" data-status={game.status}>{game.status}</span>

            <div className="game-card-body">
                <div>
                    <div className="game-card-title" title={game.name}>{game.name}</div>
                    <div className="game-card-players" title={`${game.first_player_name} vs ${game.second_player_name}`}>
                        {game.first_player_name} vs {game.second_player_name}
                    </div>
                </div>

                <div className="game-card-actions">
                    {creationType === 'created' && (
                        <div className="game-action-btn" onClick={() => onDelete(game)} title="Delete">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M4 7l16 0" />
                                <path d="M10 11l0 6" />
                                <path d="M14 11l0 6" />
                                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                            </svg>
                        </div>
                    )}
                    <div className="game-action-btn" onClick={() => {
                        creationType === 'default' ? navigate(`/game/${game.link}`) : onEdit(game);
                    }} title="Edit">
                        <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z" />
                        </svg>
                    </div>
                    {creationType === 'default' ?
                        <>
                            <div className="game-action-btn" onClick={() => navigate(`/play/${game.type}/${game.link}/scoreboard`)} title="Scoreboard">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M7 4v16l13 -8z" />
                                </svg>
                            </div>
                            <div className="game-action-btn" onClick={() => navigate(`/table/stats/${game.id_table}`)} title="Stats">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
                                    <path d="M7 20h10" />
                                    <path d="M9 16v4" />
                                    <path d="M15 16v4" />
                                    <path d="M9 12v-4" />
                                    <path d="M12 12v-1" />
                                    <path d="M15 12v-2" />
                                    <path d="M12 12v-1" />
                                </svg>
                            </div>
                        </>
                        :
                        <>
                            <div className="game-action-btn" onClick={() => navigate(`/play/${game.type}/${game.link}/scoreboard`)} title="Scoreboard">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M7 4v16l13 -8z" />
                                </svg>
                            </div>
                            <div className="game-action-btn" onClick={() => navigate(`/game/stats/${game.link}`)} title="Stats">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
                                    <path d="M7 20h10" />
                                    <path d="M9 16v4" />
                                    <path d="M15 16v4" />
                                    <path d="M9 12v-4" />
                                    <path d="M12 12v-1" />
                                    <path d="M15 12v-2" />
                                    <path d="M12 12v-1" />
                                </svg>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    );
};

export const GameListItem = ({ game, creationType, onEdit, onDelete, navigate }) => {
    return (
        <div className="game-list-item" key={game.id}>
            <div className="game-list-item-status">
                <span className={`badge ${game.status === 'live' ? 'bg-danger' : (game.status === 'finished' ? 'bg-primary' : 'bg-blue-lt')}`}>{game.status}</span>
            </div>
            <div className="game-list-item-info">
                <div className="game-list-item-title">{game.name}</div>
                <div className="game-list-item-players">
                    {game.first_player_name} vs {game.second_player_name}
                </div>
            </div>
            <div className="game-list-item-actions">
                {creationType === 'created' && (
                    <button className="btn btn-icon btn-ghost-danger" onClick={() => onDelete(game)} title="Delete">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M4 7l16 0" />
                            <path d="M10 11l0 6" />
                            <path d="M14 11l0 6" />
                            <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                            <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                        </svg>
                    </button>
                )}
                <button className="btn btn-icon btn-ghost-primary" onClick={() => {
                    creationType === 'default' ? navigate(`/game/${game.link}`) : onEdit(game);
                }} title="Edit">
                    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z" />
                    </svg>
                </button>
                {creationType === 'default' ?
                    <>
                        <button className="btn btn-icon btn-ghost-success" onClick={() => navigate(`/play/${game.type}/${game.link}/scoreboard`)} title="Scoreboard">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M7 4v16l13 -8z" />
                            </svg>
                        </button>
                        <button className="btn btn-icon btn-ghost-info" onClick={() => navigate(`/table/stats/${game.id_table}`)} title="Stats">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
                                <path d="M7 20h10" />
                                <path d="M9 16v4" />
                                <path d="M15 16v4" />
                                <path d="M9 12v-4" />
                                <path d="M12 12v-1" />
                                <path d="M15 12v-2" />
                                <path d="M12 12v-1" />
                            </svg>
                        </button>
                    </>
                    :
                    <>
                        <button className="btn btn-icon btn-ghost-success" onClick={() => navigate(`/play/${game.type}/${game.link}/scoreboard`)} title="Scoreboard">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M7 4v16l13 -8z" />
                            </svg>
                        </button>
                        <button className="btn btn-icon btn-ghost-info" onClick={() => navigate(`/game/stats/${game.link}`)} title="Stats">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
                                <path d="M7 20h10" />
                                <path d="M9 16v4" />
                                <path d="M15 16v4" />
                                <path d="M9 12v-4" />
                                <path d="M12 12v-1" />
                                <path d="M15 12v-2" />
                                <path d="M12 12v-1" />
                            </svg>
                        </button>
                    </>
                }
            </div>
        </div>
    );
};

const CombinedGameTab = ({ games, tables, activePane, setActivePane, onEdit, onDelete, navigate, viewMode }) => {
    const { isLight } = useTheme();
    const gameTypes = ['snooker', 'mini-snooker', 'pool', 'us-pool', 'chinese-pool'];

    const isMiniSnooker = (game) => {
        if (game.type !== 'snooker') return false;
        const tableId = game.id_table;
        const table = tables.find(t => t.id == tableId);
        return table && table.pricing_type === 'mini';
    };

    const filterGames = (gamesList, type) => {
        return gamesList.filter(g => {
            if (type === 'mini-snooker') {
                return isMiniSnooker(g);
            } else if (type === 'snooker') {
                return g.type === 'snooker' && !isMiniSnooker(g);
            } else {
                return g.type === type;
            }
        });
    };

    const defaultGames = games.filter(g => g.deleted_at === null && g.creation_type === 'default');
    const definedGames = games.filter(g => g.deleted_at === null && g.creation_type === 'created' && g.status !== 'finished');

    const availableTypes = gameTypes.filter(type =>
        filterGames(defaultGames, type).length > 0 || filterGames(definedGames, type).length > 0
    );

    return (
        <div className="games-page-container">
            <div className="games-sidebar">
                <div className="list-group">
                    {availableTypes.map(type => (
                        <button
                            key={type}
                            type="button"
                            className={`list-group-item list-group-item-action ${activePane === type ? 'active' : ''}`}
                            onClick={() => setActivePane(type)}
                        >
                            {type === 'chinese-pool' ? 'Hey ball' : (type === 'mini-snooker' ? 'Mini Snooker' : type.charAt(0).toUpperCase() + type.slice(1).replace('-', ' '))}
                        </button>
                    ))}
                </div>
            </div>

            <div className="games-content">
                {availableTypes.map(type => {
                    const typeDefaultGames = filterGames(defaultGames, type);
                    const typeDefinedGames = filterGames(definedGames, type);

                    if (activePane !== type) return null;

                    return (
                        <div key={type} className="fade-in">
                            {/* Default (tables) section */}
                            {typeDefaultGames.length > 0 && (
                                <div className={viewMode === 'list' ? "games-list mb-4" : "games-grid mb-4"}>
                                    {typeDefaultGames.map(game => (
                                        viewMode === 'list' ? (
                                            <GameListItem
                                                key={game.id}
                                                game={game}
                                                creationType={'default'}
                                                onEdit={onEdit}
                                                onDelete={onDelete}
                                                navigate={navigate}
                                            />
                                        ) : (
                                            <GameCard
                                                key={game.id}
                                                game={game}
                                                creationType={'default'}
                                                onEdit={onEdit}
                                                onDelete={onDelete}
                                                navigate={navigate}
                                            />
                                        )
                                    ))}
                                </div>
                            )}

                            {typeDefaultGames.length > 0 && typeDefinedGames.length > 0 && (
                                <hr className="my-4" />
                            )}

                            {/* Defined matches section */}
                            {typeDefinedGames.length > 0 && (
                                <>
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <h3 className="m-0">Defined Matches</h3>
                                        <span className="d-flex cursor-pointer align-items-center text-muted" onClick={() => { navigate('/games/finished') }} >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M12 8v4l2 2" />
                                                <path d="M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0" />
                                            </svg>
                                            Games archive
                                        </span>
                                    </div>
                                    <div className={viewMode === 'list' ? "games-list" : "games-grid"}>
                                        {typeDefinedGames.map(game => (
                                            viewMode === 'list' ? (
                                                <GameListItem
                                                    key={game.id}
                                                    game={game}
                                                    creationType={'created'}
                                                    onEdit={onEdit}
                                                    onDelete={onDelete}
                                                    navigate={navigate}
                                                />
                                            ) : (
                                                <GameCard
                                                    key={game.id}
                                                    game={game}
                                                    creationType={'created'}
                                                    onEdit={onEdit}
                                                    onDelete={onDelete}
                                                    navigate={navigate}
                                                />
                                            )
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const Games = () => {
    const navigate = useNavigate();
    const [games, setGames] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedGame, setSelectedGame] = useState(null);
    const [players, setPlayers] = useState([]);
    const [tables, setTables] = useState([]);
    const [relatedGames, setRelatedGames] = useState([]);
    const [activePane, setActivePane] = useState('snooker');
    const [gameName, setGameName] = useState('');
    const [gameType, setGameType] = useState('snooker');
    const [gameDate, setGameDate] = useState('');
    const [gameStatus, setGameStatus] = useState(null);
    const [gameTable, setGameTable] = useState(null);
    const [gameHasFlags, setGameHasFlags] = useState(false);
    const [gameIsRace, setGameIsRace] = useState(false);
    const [gameRaceTo, setGameRaceTo] = useState(2);
    const [gameFirstPlayer, setGameFirstPlayer] = useState(null);
    const [gameSecondPlayer, setGameSecondPlayer] = useState(null);
    const [linkedGameId, setLinkedGameId] = useState(null);
    const [loading, setLoading] = useState(true);
    const { user, isAuthenticated } = useAuth();
    const [isSaving, setIsSaving] = useState(false);
    const savingRef = useRef(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteLabel, setDeleteLabel] = useState('');
    const [deleteLinkedWarning, setDeleteLinkedWarning] = useState(null);
    const [isAndroidTV, setIsAndroidTV] = useState(false);
    const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'

    useEffect(() => {
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;
        if (isAndroid) {
            setIsAndroidTV(true);
            setViewMode('list');
        }
    }, []);

    const getClubGames = async (id) => {
        const data = await apiService.post('/club/games', { id_user: id });
        setGames(data.games);
    };

    const getClubTables = async (id) => {
        const data = await apiService.post('/club/tables', { id });
        setTables(data.tables);
    };

    const getClubPlayers = async (id) => {
        const data = await apiService.post('/club/game/players', { id });
        setPlayers(data.players);
        if (data.players.length > 0) {
            setGameFirstPlayer(data.players[0].id);
            setGameSecondPlayer(data.players[1]?.id || data.players[0].id);
        }
    };

    const getTableGames = async (id_user, game_link) => {
        try {
            const data = await apiService.post('/club/table-games', { id_user, game_link });
            setRelatedGames(data.games || []);
        } catch (e) {
            console.error('Failed to fetch related games:', e);
            setRelatedGames([]);
        }
    };

    const saveGame = async () => {
        if (savingRef.current) return;
        savingRef.current = true;
        setIsSaving(true);

        if (selectedGame?.creation_type === 'created' && !gameTable) {
            alert('Please select a table for the game.');
            setIsSaving(false);
            savingRef.current = false;
            return;
        }

        try {
            const payload = {
                name: gameName,
                type: gameType,
                date: gameDate,
                status: gameStatus,
                has_flags: gameHasFlags ? '1' : '0',
                is_race: gameIsRace ? '1' : '0',
                race_to: gameIsRace ? gameRaceTo : null,
                first_player: gameFirstPlayer,
                second_player: gameSecondPlayer,
                creation_type: selectedGame?.creation_type || 'created',
            };
            if (payload.creation_type === 'created' && gameTable) {
                payload.table = gameTable;
            }
            if (payload.creation_type === 'default') {
                payload.linked_game_id = linkedGameId || null;
            }

            if (selectedGame) {
                await apiService.post('/club/game/edit', { id: selectedGame.link, ...payload });
            } else {
                await apiService.post('/club/game/store', payload);
            }

            await getClubGames(user.id);
            setOpen(false);
            setGameName('');
            setGameType('snooker');
            setGameDate('');
            setGameStatus(null);
            setGameTable(null);
            setGameHasFlags(false);
            setGameIsRace(false);
            setGameRaceTo(2);
            setGameFirstPlayer(players[0]?.id || null);
            setGameSecondPlayer(players[1]?.id || null);
            setLinkedGameId(null);
            setSelectedGame(null);
        } catch (e) {
            console.error('Error saving game:', e);
        } finally {
            setIsSaving(false);
            savingRef.current = false;
        }
    };

    const deleteGame = async (id) => {
        await apiService.post('/club/game/delete', {
            id: id,
            id_user: user.id
        });
        setGames(games.filter(g => g.id !== id));
    };

    const requestDelete = (game) => {
        setDeleteId(game.id);
        setDeleteLabel(`${game.name} — ${game.first_player_name} vs ${game.second_player_name}`);
        // Check if this match is currently linked to a table's default game
        const linkingTable = games.find(g => g.creation_type === 'default' && String(g.linked_game_id) === String(game.id));
        setDeleteLinkedWarning(linkingTable ? linkingTable.name : null);
        setConfirmOpen(true);
    };

    const confirmDelete = async () => {
        if (isDeleting || deleteId == null) return;
        setIsDeleting(true);
        try {
            await deleteGame(deleteId);
            setConfirmOpen(false);
            setDeleteId(null);
            setDeleteLabel('');
            setDeleteLinkedWarning(null);
        } catch (e) {
            console.error(e);
        } finally {
            setIsDeleting(false);
        }
    };

    const handleEdit = (game) => {
        setSelectedGame(game);
        setOpen(true);
    };

    const filteredRelatedGames = useMemo(() => {
        return relatedGames.filter(rg => {
            return (
                rg?.type === gameType &&
                (['created', 'live'].includes(rg?.status) ||
                    (rg?.status === 'finished' && rg?.id === linkedGameId))
            );
        });
    }, [relatedGames, gameType, linkedGameId]);

    useEffect(() => {
        if (selectedGame) {
            const tableId = selectedGame.id_table != null ? String(selectedGame.id_table) : null;
            const selectedTable = tableId ? tables.find(t => String(t.id) === tableId) : null;

            setGameName(selectedGame.name || '');
            setGameType(selectedGame.type || 'snooker');
            setGameDate(selectedGame.date ? new Date(selectedGame.date).toISOString().split('T')[0] : '');
            setGameStatus(selectedGame.status || 'created');
            setGameHasFlags(selectedGame.has_flags == 1 || selectedGame.has_flags === '1');
            setGameIsRace(selectedGame.is_race == 1 || selectedGame.is_race === '1');
            setGameRaceTo(selectedGame.race_to || 2);
            setGameFirstPlayer(selectedGame.first_player || players[0]?.id || null);
            setGameSecondPlayer(selectedGame.second_player || players[1]?.id || null);
            setLinkedGameId(selectedGame.linked_game_id || null);

            if (selectedGame.creation_type === 'default') {
                setGameTable(null);
                getTableGames(user.id, selectedGame.link);
                setRelatedGames([]);
            } else {
                setGameTable(selectedTable ? tableId : (tables.length > 0 ? String(tables[0].id) : null));
                setRelatedGames([]);
            }
        } else {
            setGameName('');
            setGameType('snooker');
            setGameDate('');
            setGameStatus(null);
            setGameTable(tables.length > 0 ? String(tables[0].id) : null);
            setGameHasFlags(false);
            setGameIsRace(false);
            setGameRaceTo(2);
            setGameFirstPlayer(players[0]?.id || null);
            setGameSecondPlayer(players[1]?.id || null);
            setLinkedGameId(null);
            setRelatedGames([]);
        }
    }, [selectedGame, tables, players, user]);

    useEffect(() => {
        if (games.length > 0) {
            const gameTypes = ['snooker', 'pool', 'us-pool', 'chinese-pool'];
            const defaultFilteredGames = games.filter(g => g.deleted_at === null && g.creation_type === 'default');
            const createdFilteredGames = games.filter(g => g.deleted_at === null && g.creation_type === 'created' && g.status !== 'finished');

            const availableTypes = gameTypes.filter(type =>
                defaultFilteredGames.some(g => g.type === type) || createdFilteredGames.some(g => g.type === type)
            );

            const firstAvailableType = availableTypes.length > 0 ? availableTypes[0] : 'snooker';
            setActivePane(firstAvailableType);
        }
    }, [games]);

    useEffect(() => {
        if (user) {
            setLoading(true);
            Promise.all([
                getClubGames(user.id),
                getClubTables(user.id),
                getClubPlayers(user.id)
            ]).finally(() => {
                setLoading(false);
            });
        }
    }, [user]);

    if (loading) {
        return (
            <div className="page-wrapper">
                <div className="page-body">
                    <div className="container-xl w-100">
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`page-wrapper ${isAndroidTV ? 'android-tv-layout' : ''}`}>
            <div className="page-header d-print-none">
                <div className="container-xl">
                    <div className="row g-2 align-items-center">
                        <div className="col">
                            <div className="page-pretitle">
                                Matches
                            </div>
                            {isAuthenticated() ?
                                <h2 className="page-title">
                                    {(user) ? user.name : ''}
                                </h2>
                                : null
                            }
                        </div>
                        <div className="col-auto ms-auto d-print-none">
                            <div className="btn-list">
                                <button className="btn btn-icon btn-ghost-secondary me-2" onClick={() => setViewMode(viewMode === 'grid' ? 'list' : 'grid')} title={viewMode === 'grid' ? "Switch to List View" : "Switch to Grid View"}>
                                    {viewMode === 'grid' ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M9 6l11 0" />
                                            <path d="M9 12l11 0" />
                                            <path d="M9 18l11 0" />
                                            <path d="M5 6l0 .01" />
                                            <path d="M5 12l0 .01" />
                                            <path d="M5 18l0 .01" />
                                        </svg>
                                    ) : (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M4 4h6v6h-6z" />
                                            <path d="M14 4h6v6h-6z" />
                                            <path d="M4 14h6v6h-6z" />
                                            <path d="M14 14h6v6h-6z" />
                                        </svg>
                                    )}
                                </button>
                                <button type="button" className="btn btn-primary d-none d-sm-inline-flex club-page-primary-action" onClick={() => { setSelectedGame(null); setOpen(true); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M12 5l0 14" />
                                        <path d="M5 12l14 0" />
                                    </svg>
                                    Create new match
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-body">
                <div className="container-xl">
                    <div className="row row-deck row-cards">
                        <div className="col-12">
                            <CombinedGameTab
                                games={games}
                                tables={tables}
                                activePane={activePane}
                                setActivePane={setActivePane}
                                onEdit={handleEdit}
                                onDelete={requestDelete}
                                navigate={navigate}
                                viewMode={viewMode}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className={`modal modal-blur fade ${open ? 'show' : ''}`} id="modal-large" tabIndex="-1" role="dialog" aria-hidden="true" style={open ? { display: 'block' } : { display: 'none' }}>
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{selectedGame ? 'Edit Match' : 'Create New Match'}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setOpen(false)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6 mb-3">
                                    <label className="mb-2 ml-2">Game name</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Game name"
                                        value={gameName}
                                        onChange={(e) => setGameName(e.target.value)}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label className="mb-2 ml-2">Game type</label>
                                    <select
                                        className="form-control"
                                        value={gameType}
                                        onChange={(e) => setGameType(e.target.value)}
                                        disabled={selectedGame}
                                    >
                                        <option value="snooker">Snooker</option>
                                        <option value="pool">Pool</option>
                                        <option value="us-pool">US Pool</option>
                                        <option value="chinese-pool">Chinese Pool</option>
                                    </select>
                                </div>
                                <div className="col-lg-12 mb-3">
                                    <label className="mb-2 ml-2">Game date</label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        placeholder="Game date"
                                        value={gameDate}
                                        onChange={(e) => setGameDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-lg-6 mb-3">
                                    <label className="mb-2 ml-2">Game status</label>
                                    <select
                                        className="form-control"
                                        value={gameStatus || ''}
                                        onChange={(e) => setGameStatus(e.target.value)}
                                    >
                                        <option value="created">Created</option>
                                        <option value="live">Live</option>
                                        <option value="finished">Finished</option>
                                    </select>
                                </div>
                                {selectedGame?.creation_type === 'default' ? (
                                    <div className="col-lg-6 mb-3">
                                        <label className="mb-2 ml-2">Linked Match</label>
                                        <select
                                            className="form-control"
                                            value={linkedGameId || ''}
                                            onChange={(e) => setLinkedGameId(e.target.value)}
                                            disabled={filteredRelatedGames.length === 0}
                                        >
                                            <option value="">Select a linked match</option>
                                            {filteredRelatedGames.length === 0 ? (
                                                <option value="" disabled>No matching games available</option>
                                            ) : (
                                                filteredRelatedGames.map((g) => (
                                                    <option key={g.id} value={g.id}>
                                                        {(g.name || 'Unnamed Game')} - {(g.first_player_name || 'Player 1')} vs {(g.second_player_name || 'Player 2')}
                                                    </option>
                                                ))
                                            )}
                                        </select>
                                    </div>
                                ) : (
                                    <div className="col-lg-6 mb-3">
                                        <label className="mb-2 ml-2">Table</label>
                                        <select
                                            className="form-control"
                                            value={gameTable ?? ''}
                                            onChange={(e) => {
                                                setGameTable(e.target.value);
                                            }}
                                            disabled={tables.length === 0}
                                        >
                                            <option value="">Select a table</option>
                                            {tables
                                                .filter((t) => t.type === gameType)
                                                .map((table) => (
                                                    <option key={table.id} value={String(table.id)}>
                                                        {table.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                )}
                                <div className="col-lg-6 mt-3">
                                    <div className="is-race" style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                        <Checkbox style={{ marginRight: 8 }} toggle checked={gameIsRace === true || gameIsRace === 1 || gameIsRace === "1"} onChange={() => setGameIsRace(!gameIsRace)} />
                                        <label className="text-white">is Race</label>
                                    </div>
                                </div>
                                <div className="col-lg-6 mt-3">
                                    <div className="has-flags" style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                        <Checkbox style={{ marginRight: 8 }} toggle checked={gameHasFlags === true || gameHasFlags === 1 || gameHasFlags === "1"} onChange={() => setGameHasFlags(!gameHasFlags)} />
                                        <label className="text-white">Has flags</label>
                                    </div>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <div className="is-race-cnt" style={{ marginTop: 10 }}>
                                        {(gameIsRace === true || gameIsRace === 1 || gameIsRace === "1") ? (
                                            <div className="race_to" style={{ width: '100%', marginTop: 10 }}>
                                                <label className="mb-2 ml-2" style={{ display: 'block', width: '100%' }}>First to</label>
                                                <input
                                                    className="form-control"
                                                    style={{ display: 'block', width: '100%' }}
                                                    type="number"
                                                    placeholder="First to"
                                                    value={gameRaceTo}
                                                    onChange={(e) => setGameRaceTo(Number(e.target.value))}
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <h3 className="mt-4" style={{ textAlign: 'center' }}>Players</h3>
                                <div className="col-lg-6">
                                    <label className="mb-2 ml-2" style={{ width: '100%' }}>Change the player?</label>
                                    <select
                                        className="form-control"
                                        style={{ width: '100%', margin: '5px 0px' }}
                                        value={gameFirstPlayer || ''}
                                        onChange={(e) => setGameFirstPlayer(e.target.value)}
                                    >
                                        <option value="">Select a player</option>
                                        {players.map((player) => (
                                            <option key={player.id} value={player.id}>
                                                {player.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-6">
                                    <label className="mb-2 ml-2" style={{ width: '100%' }}>Change the player?</label>
                                    <select
                                        className="form-control"
                                        style={{ width: '100%', margin: '5px 0px' }}
                                        value={gameSecondPlayer || ''}
                                        onChange={(e) => setGameSecondPlayer(e.target.value)}
                                    >
                                        <option value="">Select a player</option>
                                        {players.map((player) => (
                                            <option key={player.id} value={player.id}>
                                                {player.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn me-auto" data-bs-dismiss="modal" onClick={() => setOpen(false)}>Close</button>
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={saveGame} disabled={isSaving}>
                                {isSaving ? 'Saving...' : 'Save changes'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`modal modal-blur fade ${confirmOpen ? 'show' : ''}`} id="modal-danger" tabIndex="-1" role="dialog" aria-hidden="true" style={confirmOpen ? { display: 'block' } : { display: 'none' }}>
                <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-status bg-danger"></div>
                        <div className="modal-body text-center py-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="icon mb-2 text-danger icon-lg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 9v2m0 4v.01" />
                                <path d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75" />
                            </svg>
                            <h3>Are you sure?</h3>
                            <div className="text-muted">Do you really want to remove the following game: <strong>{deleteLabel}</strong></div>
                            {deleteLinkedWarning && (
                                <div className="alert alert-warning mt-2 mb-0" style={{ fontSize: '0.85rem' }}>
                                    This match is currently linked to <strong>{deleteLinkedWarning}</strong>. Deleting it will reset that table back to the default game.
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <div className="w-100">
                                <div className="row">
                                    <div className="col">
                                        <button className="btn w-100" data-bs-dismiss="modal" onClick={() => setConfirmOpen(false)}>
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col">
                                        <button className="btn btn-danger w-100" data-bs-dismiss="modal" onClick={confirmDelete}>
                                            Delete game
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Games;
